import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { ResponseEnum } from "enums/response";
import { NoInfer } from "react-redux";
import { ApiResponse } from "types/api";
import { AuthStateType, LoginResponse } from "types/auth";

import {
  recoveryPassword,
  signInWithCredentials,
  signUpWithCredentials,
  verifyToken,
} from "./auth.thunk";
export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<AuthStateType>>
) => {
  builder.addCase(signInWithCredentials.pending, (state: AuthStateType) => {
    state.isLoading = true;
  });
  builder.addCase(
    signInWithCredentials.fulfilled,
    (
      state: AuthStateType,
      action: PayloadAction<LoginResponse | undefined>
    ) => {
      state.isLoading = false;
      if (!action.payload) return;

      if (action.payload.msg !== ResponseEnum.msgSuccess) {
        state.messageRes = "Incorrect username or password";
        return;
      }

      const { username, token } = action.payload;
      localStorage.setItem("token", token);
      localStorage.setItem("username", username);
      state.username = username;
      state.token = token;
      state.messageRes = "";
      state.isAuthenticated = true;
    }
  );
  builder
    .addCase(verifyToken.pending, (state: AuthStateType) => {
      state.isLoading = true;
    })
    .addCase(
      verifyToken.fulfilled,
      (state: AuthStateType, action: PayloadAction<string | undefined>) => {
        if (!action.payload) {
          state.isAuthenticated = false;
          state.isLoading = false;
          localStorage.clear();
          return;
        }
        state.isAuthenticated = true;
        state.username = action.payload;
        state.token = localStorage.getItem("token") || "";
        state.isLoading = false;
      }
    );
  builder.addCase(signUpWithCredentials.pending, (state: AuthStateType) => {
    state.isLoading = true;
  });
  builder.addCase(
    signUpWithCredentials.fulfilled,
    (state: AuthStateType, action: PayloadAction<ApiResponse | undefined>) => {
      state.isLoading = false;
      if (!action.payload) return;

      if (action.payload.msg !== ResponseEnum.msgSuccess) {
        state.messageRes =
          action.payload.msg === "Mobile has already been taken"
            ? "Phone number already exist"
            : action.payload.msg;
        return;
      }

      state.messageRes = "";
    }
  );
  builder.addCase(
    recoveryPassword.fulfilled,
    (state: AuthStateType, action: PayloadAction<ApiResponse | undefined>) => {
      if (!action.payload) return;

      if (action.payload.status !== ResponseEnum.statusSuccess) {
        state.messageRes = action.payload.msg;
        return;
      }

      state.messageRes = "";
    }
  );
};
